import React from "react";
import styles from "./Modal.module.scss"; // Create a CSS/SCSS file for styling
import classNames from "classnames";

const Modal = ({
  isOpen,
  size = "medium",
  children,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
  size?: "medium" | "large";
  children: any;
}) => {
  if (!isOpen) return null;

  return (
    <div
      className={styles.modalBackdrop}
      onClick={(event) => event.stopPropagation()}
    >
      <div className={classNames(styles.madalContainer, styles[size])}>
        <button className={styles.closeButton} onClick={onClose}></button>
        <div className={styles.modalContent}>{children}</div>
      </div>
    </div>
  );
};
export default Modal;
